import React, { Component, Fragment, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import _get from 'lodash/get';
import { chatResetMessage } from '../../../Actions/GroupChatMessageActions';
import { UnreadCountDelete, UnreadCountUpdate } from '../../../Actions/UnreadCount';
import {
    Camera,
    Contact,
    DocumentIcon,
    Location,
    VideoIcon2,
    RecentVideoCall,
    RecentAudioCall,
    ChatAudioRecorderDark,
    RecentCallHangup,
    AudioOn,
    AudioOff,
    RecentDeletedMessage,
    ChatMute,
    DropdownArrow,
    IconMissedCallAudio,
    IconMissedCallVideo,
    IconUnarchive,
    ChatAudioRecorder,
    Delete,
    LeaveIcon,
    MuteInfo2,
    UnMuteInfo2,
} from '../../../assets/images';
import { groupstatus } from '../../../Helpers/Chat/RecentChat';
import IndexedDb from '../../../Helpers/IndexedDb';
import {
    getFormatPhoneNumber,
    getFormattedRecentChatText,
    getHighlightedText,
    capitalizeFirstLetter,
    capitalizeTxt,
    sendNotification,
    blockOfflineAction,
    getArchiveSetting,
    shouldHideNotification,
    getConversationHistoryTime,
    isAppOnline,
    updateMuteNotification,
} from '../../../Helpers/Utility';
import Store from '../../../Store';
import { getAvatarImage, groupAvatar } from '../Common/Avatarbase64';
import ProfileImage from '../Common/ProfileImage';
import { convertUTCTOLocalTimeStamp, formatChatDateTime } from '../WebChatTimeStamp';
import Message from './Message';
import {
    formatGroupIdToJid,
    formatUserIdToJid,
    getContactNameFromRoster,
    getDataFromRoster,
    handleMentionedUser,
    initialNameHandle,
    isLocalUser,
} from '../../../Helpers/Chat/User';
import {
    CHAT_TYPE_GROUP,
    CHAT_TYPE_SINGLE,
    GROUP_CHAT_PROFILE_UPDATED_NOTIFY,
    MUTE_STATUS,
    THIS_MESSAGE_WAS_DELETED,
    YOU_DELETED_THIS_MESSAGE,
} from '../../../Helpers/Chat/Constant';
import {
    notificationMessageType,
    isActiveConversationUserOrGroup,
    isTextMessage,
    isGroupChat,
    getActiveConversationUserOrGroupId,
} from '../../../Helpers/Chat/ChatHelper';
import browserTab from '../../../Helpers/Browser/BrowserTab';
import { isMuteAudioAction } from '../../../Actions/CallAction';
import SDK from '../../SDK';
import { muteLocalAudio } from '../../callbacks';
import { disconnectCallConnection } from '../../../Helpers/Call/Call';
import { Archived, IconPinChat } from '../Setting/images';
import { toast } from 'react-toastify';
import { updateArchiveStatusRecentChat, updateMuteStatusRecentChat } from '../../../Actions/RecentChatActions';
import OutsideClickHandler from 'react-outside-click-handler';
import Modal from '../Common/Modal';
import browserNotify from '../../../Helpers/Browser/BrowserNotify';
import { getFromLocalStorageAndDecrypt } from '../WebChatEncryptDecrypt';
import { isMatchingUserId } from '../../../features/calls/utils/helper';
import { CALLKIT_CALLSCREENSTATUS } from '../../../features/calls/constants';
import PropTypes from 'prop-types';
import { isString } from 'lodash';
import { useDispatch } from 'react-redux';
import {
    Dialog,
    DialogAction,
    DialogClose,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from '../../../ui/Dialog';
import { SHOW_REACTIONS_FEATURE } from '../../processENV';
import { emojiUtils } from '../../../Helpers/EmojiUtils';
const HtmlToReactParser = require('html-to-react').Parser;
const htmlToReactParser = new HtmlToReactParser();

const allowedIds = ['recent-menu', 'recent-menu-archive', 'recent-menu-archive-icon', 'recent-menu-archive-text'];
class RecentChatItem extends Component {
    constructor(props = {}) {
        super(props);
        this.state = {
            image: null,
            showModal: false,
            recentDrop: false,
            pinChat: false,
            archiveChat: false,
            isArchive: true,
            needToImplement: false,
            PrevUnreadCount: 0,
            dropUp: false,
        };
        this.localDb = new IndexedDb();
        this.audio = new Audio('sounds/busySignal.mp3');
    }
    getContactName = () => {
        const { item = {} } = this.props;
        return getContactNameFromRoster(item.roster);
    };

    handleToggleMute = () => {
        const { callkitData } = this.props;
        const localUser = (callkitData?.ongoingCallParticipants || []).find(p => isLocalUser(p.userId));
        const isAudioMuted = localUser?.isAudioMuted || false;
        SDK.muteAudio(!isAudioMuted);
    };

    stopAudio() {
        this.audio.loop = false;
        this.audio.pause();
        this.audio.currentTime = 0;
    }

    handleToggleHangUpCall = () => {
        this.stopAudio();
        const { callkitData } = this.props;
        if (callkitData?.callScreenStatus === CALLKIT_CALLSCREENSTATUS.INCOMING) {
            SDK.declineCall();
        } else {
            SDK.endCall();
        }
    };

    // Helper to escape raw HTML-like tags
    escapeHtmlIfNeeded(str) {
        if (typeof str === 'string') {
            return str.replace(/</g, '&lt;').replace(/>/g, '&gt;');
        }
        return str;
    }

    formatMessage = (msgBody, msgType) => {
        let message = msgBody.message;
        const { item: { recent: { chatType } } = {} } = this.props;

        if (['image', 'video', 'audio', 'file', 'contact', 'location', 'meet'].indexOf(msgType) > -1) {
            // Media type icon mapping
            const icons = {
                image: (
                    <i className="chat-camera">
                        <Camera />
                    </i>
                ),
                video: (
                    <i className="chat-video">
                        <VideoIcon2 />
                    </i>
                ),
                audio: (
                    <i
                        className={` ${_get(msgBody, 'media.audioType', '') !== 'recording' ? 'audio' : 'mic'} chat-audio`}
                    >
                        {_get(msgBody, 'media.audioType', '') !== 'recording' ? (
                            <ChatAudioRecorderDark />
                        ) : (
                            <ChatAudioRecorder />
                        )}
                    </i>
                ),
                file: (
                    <i className="chat-docu">
                        <DocumentIcon />
                    </i>
                ),
                contact: (
                    <i className="chat-contact">
                        <Contact />
                    </i>
                ),
                location: (
                    <i className="chat-location">
                        <Location />
                    </i>
                ),
                missedCallAudio: (
                    <i className="chat-missedcall">
                        <IconMissedCallAudio />
                    </i>
                ),
                missedCallVideo: (
                    <i className="chat-missedcall">
                        <IconMissedCallVideo />
                    </i>
                ),
                // meet: (
                //   <i className="chat-meet">
                //     <IconCalendarTime />
                //   </i>
                // )
            };

            if (msgBody && typeof msgBody === 'object') {
                if (msgType === 'meet') {
                    message = msgBody?.meet?.link;
                } else if (msgType === 'image') {
                    message = 'Photo';
                } else if (msgType === 'file') {
                    message = 'Document';
                } else {
                    message = capitalizeFirstLetter(msgType);
                }

                if (msgBody?.media?.caption) {
                    
                    try {
                        const tmp = document.createElement('div');
                        tmp.innerHTML = msgBody.media.caption;

                        const nodes = Array.from(tmp.childNodes || []);
                        const out = [];
                        let prevWasEmpty = false;

                        const isNodeEmpty = node => {
                            if (!node) return true;
                            if (node.nodeType === Node.TEXT_NODE) {
                                return (node.textContent || '').replace(/\u00A0/g, ' ').trim().length === 0;
                            }
                            if (node.nodeType === Node.ELEMENT_NODE) {
                                // If element contains a mention span, treat as non-empty
                                if (node.querySelector && node.querySelector('span[data-mentioned]')) return false;
                                const inner = (node.innerHTML || '').replace(/<br\s*\/?\>/gi, '').replace(/&nbsp;/g, '').trim();
                                return inner.length === 0;
                            }
                            return true;
                        };

                        nodes.forEach(node => {
                            const empty = isNodeEmpty(node);
                            if (empty) {
                                prevWasEmpty = true;
                                return; // skip adding now
                            }
                            // if previous nodes were empty and we already have content, add a single line break
                            if (prevWasEmpty && out.length > 0) {
                                out.push(' ');
                            }
                            if (node.nodeType === Node.TEXT_NODE) {
                                out.push(node.textContent);
                            } else if (node.nodeType === Node.ELEMENT_NODE) {
                                const tag = (node.tagName || '').toLowerCase();
                                // For block-level wrappers (div, p), unwrap and keep inner HTML
                                if (tag === 'div' || tag === 'p') {
                                    out.push(node.innerHTML || '');
                                } else {
                                    out.push(node.outerHTML);
                                }
                            }
                            prevWasEmpty = false;
                        });

                        // join reconstructed parts; this removes leading/trailing empty blocks
                        message = out.join('');
                        // Convert mention spans to placeholder for downstream handling
                        const regex = /<span\s[^>]*>@([^<]+)<\/span>/g;
                        message = message.replace(regex, '@[?]');                        
                        
                    } catch (e) {
                        message = msgBody.media.caption;
                    }
                }
            }

            message = htmlToReactParser.parse(
                handleMentionedUser({
                    text: getFormattedRecentChatText(message),
                    mentionedUsersIds: msgBody.mentionedUsersIds || [],
                    mentionedMe: false,
                    mentionedClass: '',
                    chatType,
                }),
            );

            return (
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                    {(message && icons[msgType]) || ''} <p>{message}</p>
                </div>
            );
        }

        const safeText = this.escapeHtmlIfNeeded(getFormattedRecentChatText(message));
        
        const parsed = htmlToReactParser.parse(
            handleMentionedUser({
                text: safeText,
                mentionedUsersIds: msgBody.mentionedUsersIds || [],
                mentionedMe: false,
                mentionedClass: '',
                chatType: null,
            }),
        );

        return parsed;
    };

    getDeletedText = publisherId =>
        isLocalUser(publisherId) ? (
            <span className="text-italic innerSpan">{YOU_DELETED_THIS_MESSAGE}</span>
        ) : (
            <span className="text-italic innerSpan">{THIS_MESSAGE_WAS_DELETED}</span>
        );

    /**
     * handleLastMessage function is to handle the last message publisher name along with last message.
     */
    handleLastMessage = data => {
        const { vCardData: { data: { fromUser } = {} } = {} } = this.props;
        const {
            recent: { chatType, publisherId, msgBody, msgType },
        } = data;

        const conditionArray = [{ condition: 'groupchat' }, { condition: 'broadcast' }];
        const conditionCheck = conditionArray.some(ele => ele.condition === chatType);

        if (conditionCheck) {
            // if (publisherId !== fromUser) {
            const senderDetails = getDataFromRoster(publisherId);

            if (senderDetails) {
                const lastMessageBy = publisherId === fromUser ? 'You' : getContactNameFromRoster(senderDetails);
                const lastMessage = this.formatMessage(msgBody, msgType);
                const hasMentionButtons = childrenArray => {
                    if (isString(childrenArray)) return true;
                    if (!Array.isArray(childrenArray)) return false;
                    return childrenArray.some(item => {
                        return React.isValidElement(item) && item.type === 'button';
                    });
                };

                return (
                    <Fragment>
                        {lastMessageBy && <span className="groupLastMessageBy">{lastMessageBy}: </span>}
                        {lastMessage && (
                            <span
                                className={`groupLastMessage ${
                                    lastMessage?.type === 'button' || hasMentionButtons(lastMessage) ? 'grouptag' : ''
                                }`}
                            >
                                {_get(this.props, 'item.recent.deleteStatus', 0) === 1 ? (
                                    <div className="deleted">
                                        <i className="recallMsgIcon">
                                            <RecentDeletedMessage />
                                        </i>
                                        <div className="deleted-message text-italic">{THIS_MESSAGE_WAS_DELETED}</div>
                                    </div>
                                ) : (
                                    lastMessage
                                )}
                            </span>
                        )}
                    </Fragment>
                );
            }
            const unknownPublisher = senderDetails?.mobileNumber
                ? getFormatPhoneNumber(senderDetails.mobileNumber)
                : publisherId;
            return (
                <Fragment>
                    {unknownPublisher && <span className="groupLastMessageBy">{unknownPublisher}: </span>}
                    <span className="groupLastMessage">{this.formatMessage(msgBody, msgType)} </span>
                </Fragment>
            );
        }
        // }

        return _get(this.props, 'item.recent.deleteStatus', 0) === 1 ? (
            <>
                <i className="recallMsgIcon">
                    <RecentDeletedMessage />
                </i>
                {this.getDeletedText(publisherId)}
            </>
        ) : (
            this.formatMessage(msgBody, msgType)
        );
    };

    groupNotification = item => {
        const {
            rosterData: { data },
        } = this.props;
        const {
            recent: { publisherId, userId, profileUpdatedStatus, chatType },
        } = item;
        return groupstatus(publisherId, userId, profileUpdatedStatus, data, chatType);
    };

    /**
     * handleMessageType method to handle the last message type icon in recent chat section.
     * @param {object} item
     */
    handleMessageType = item => {
        const { recent = {} } = item;
        const { reactedUserName, emojiId, msgBody, msgType, deleteStatus, messageSenderId, chatType, publisherId } =
            recent;

        let updateLastReactionMessageStatus = false;

        if (chatType === 'groupchat') {
            updateLastReactionMessageStatus = deleteStatus !== 1 && reactedUserName && emojiId;
        } else {
            updateLastReactionMessageStatus = deleteStatus !== 1 && reactedUserName && emojiId;
        }


        // updateLastReactionMessageStatus = deleteStatus !== 1 && reactedUserName && emojiId && (this.props?.vCardData?.data?.userId === messageSenderId || this.props?.vCardData?.data?.userId === reactedUserName);
        // }

        let showReactionSummary = false;
        if (updateLastReactionMessageStatus && SHOW_REACTIONS_FEATURE) {
            const currentUserId = this.props?.vCardData?.data?.userId;
            if (chatType === 'chat') {
                // if (
                //     (messageSenderId ? messageSenderId : publisherId) === currentUserId ||
                //     reactedUserName === currentUserId
                // ) {
                    showReactionSummary = true;
                // }
            } else if (chatType === 'groupchat') {
                if ((messageSenderId ? messageSenderId : publisherId) === currentUserId ||
                    reactedUserName === currentUserId ) {
                    showReactionSummary = true;
                }
            }
        }

        if (showReactionSummary) {
            const emojiObj = emojiUtils.getAllEmojis().find(r => r.emojiId === emojiId);
            const emojiChar = emojiObj ? emojiObj.char : '';
            const reactorDetails = getDataFromRoster(reactedUserName);
            const reactorName = isLocalUser(reactedUserName)
                ? 'You'
                : reactorDetails
                  ? getContactNameFromRoster(reactorDetails)
                  : reactedUserName;

            let messageContent = this.formatMessage(msgBody, msgType);
            if (msgType !== 'text') {
                if (msgType === 'image') messageContent = 'Photo';
                else if (msgType === 'video') messageContent = 'Video';
                else if (msgType === 'audio') messageContent = 'Audio';
                else if (msgType === 'file') messageContent = 'Document';
                else messageContent = capitalizeFirstLetter(msgType);
            }

            const renderedMessageContent = chatType => {
                if (chatType === 'groupchat') {
                    return (
                        <span className="reaction-summary">
                            {reactorName}: reacted {emojiChar} to "{getFormattedRecentChatText(messageContent)}"
                        </span>
                    );
                } else {
                    if (reactorName === 'You') {
                        return (
                            <span className="reaction-summary">
                                {reactorName}: reacted {emojiChar} to "{getFormattedRecentChatText(messageContent)}"
                            </span>
                        );
                    } else {
                        return (
                            <span className="reaction-summary">
                                reacted {emojiChar} to "{getFormattedRecentChatText(messageContent)}"
                            </span>
                        );
                    }
                }
            };

            return <>{renderedMessageContent(chatType)}</>;
        } else {
            if (item.recent.msgType === GROUP_CHAT_PROFILE_UPDATED_NOTIFY) {
                return this.groupNotification(item);
            }
            switch (item.recent.msgType) {
                case 'text':
                case 'auto_text':
                case 'image':
                case 'video':
                case 'audio':
                case 'file':
                case 'contact':
                case 'location':
                case 'meet':
                case 'channelInvitation':
                    return this.handleLastMessage(item);
                default:
                    return null;
            }
        }
    };

    /**
     * handleTimeStamp() method to manage the message time format.
     * @param {object} response
     */
    handleTimeStamp(time) {
        return formatChatDateTime(convertUTCTOLocalTimeStamp(time), 'recent-chat');
    }

    addActiveClass = element => {
        const activeElement = element.target.closest('ul').querySelector('li.active');
        activeElement?.classList.remove('active');
        element.target.closest('li').classList.add('active');
    };

    /**
     * clickListener() method to dispatch the action with contact info payload.
     * In this method, to perform display the conversation header section.
     * @param {object} event
     * @param {object} response
     */
    clickListener = (e, response) => {
        const { recent: { fromUserId } = {} } = response;
        this.props.handlePopupState(true);
        const activeClass = e.target?.closest('li')?.classList?.contains('active');
        const recordingStatus = getFromLocalStorageAndDecrypt('recordingStatus');
        if (activeClass || recordingStatus === false) return;
        this.addActiveClass(e);
        let status = 'block';

        // When user switch chat clean it
        // Store.dispatch(clearChatSeenPendingMsg());
        Store.dispatch(chatResetMessage()).then(() => this.props.handleOnclick(status, response));
    };

    componentDidMount() {
        const { item: { roster: { image, groupImage } = {} } = {} } = this.props;
        this.setState(
            {
                image: image || groupImage,
            },
            () => {
                this.setUnreadCount();
            },
        );
    }

    setUnreadCount = () => {
        const { item: { recent: { unreadCount, fromUserId: msgfrom, chatType } } = {} } = this.props;
        if (
            !unreadCount ||
            parseInt(unreadCount) === 0 ||
            (isGroupChat(chatType) &&
                (!this.props?.item?.roster ||
                    (typeof this.props.item.roster === 'object' && Object.keys(this.props.item.roster).length === 0)))
        )
            return;
        Store.dispatch(UnreadCountUpdate({ count: parseInt(unreadCount), fromUserId: msgfrom, isRefresh: true, source: 'recentchat-refresh' }));
    };

    componentDidUpdate(prevProps) {
        const {
            item: {
                recent: { fromUserId, publisherId, chatType, muteStatus, archiveStatus = 0, editedStatus = 0 },
                roster: { image } = {},
            } = {},
            messageId,
            messageData,
        } = this.props;
        const { data: { msgType, msgId, msgBody } = {} } = messageData || {};

        if (
            msgType &&
            msgType === 'carbonSentSeen' &&
            prevProps.messageData.id !== messageData.id &&
            msgId === messageId
        ) {
            Store.dispatch(UnreadCountDelete({ fromUserId }));
        }

        if (
            this.props.refreshUnreadCount !== prevProps.refreshUnreadCount &&
            this.props.refreshUnreadCount &&
            getActiveConversationUserOrGroupId() !== fromUserId
        ) {
            this.setUnreadCount();
        }

        if (
            (this.props?.item?.recent?.msgType === GROUP_CHAT_PROFILE_UPDATED_NOTIFY &&
                this.props?.item?.recent?.timestamp !== prevProps?.item?.recent?.timestamp) ||
            prevProps?.messageId !== messageId
        ) {
            const messageFromUser = this.props?.vCardData?.data?.fromUser;
            if (!isLocalUser(publisherId)) {
                const webSettings = getFromLocalStorageAndDecrypt('websettings');
                let parserLocalStorage = webSettings ? JSON.parse(webSettings) : {};
                const { Notifications = true } = parserLocalStorage;

                if (!isActiveConversationUserOrGroup(fromUserId, chatType) || !browserTab.isVisible()) {
                    const recentChat = this.props?.item;
                    const canNotify = Notifications && muteStatus === 0 && archiveStatus !== 1 && editedStatus !== 1;
                    if (msgType && typeof msgBody === 'string' && notificationMessageType.indexOf(msgBody) > -1) {
                        const {
                            recent: { NotificationTo },
                        } = recentChat;
                        if (NotificationTo !== messageFromUser && msgBody === '2') {
                            return;
                        }
                        canNotify && this.createPushNotification(recentChat);
                    } else {
                        const { recent: { profileUpdatedStatus } } = recentChat;
                        if(["userAdded"].includes(profileUpdatedStatus)) return;
                        canNotify && this.createPushNotification(recentChat);
                    }
                } else {
                    return;
                }
            } else {
                return;
            }
        }

        if (prevProps?.item?.roster?.image !== image) {
            this.setState({
                image: image,
            });
        }
    }

    getsenderName = contactDetails => {
        return getContactNameFromRoster(contactDetails);
    };

    createPushNotification = recentChat => {
        try {
            const {
                recent: {
                    chatType,
                    msgBody: { message_type, message, mentionedUsersIds },
                    publisherId,
                    fromUserId,
                },
                roster: { image, groupImage, thumbImage },
            } = recentChat;

            const isRawTag =
                isTextMessage(message_type) &&
                /^<[^>]+>$/.test(message) && // looks like <abc>
                !/@\[\?\]/.test(message); // does NOT contain a mention

            const messageBody = isTextMessage(message_type)
                ? handleMentionedUser({
                      text: message,
                      mentionedUsersIds: mentionedUsersIds,
                      mentionedMe: null,
                      mentionedClass: null,
                      chatType: 'notification',
                  })
                : message_type === 'file'
                  ? 'Document'
                  : capitalizeTxt(message_type || '');

            let updateMessage = message_type ? messageBody : this.handleMessageType(recentChat);

            let updateDisplayName, imageToken;

            if (chatType === 'chat') {
                updateDisplayName = this.getsenderName(recentChat.roster);
                imageToken = thumbImage && thumbImage !== '' ? thumbImage : image;
            } else {
                updateDisplayName = this.getContactName();
                imageToken = thumbImage && thumbImage !== '' ? thumbImage : groupImage;
                const senderName = getContactNameFromRoster(getDataFromRoster(publisherId)) || publisherId;
                if (message_type) updateMessage = `${senderName}: ${updateMessage}`;
            }

            const {
                unreadCountData: { unreadDataObj },
            } = this.props;
            let totalChats = 0;
            let totalCounts = 0;
            Object.entries(unreadDataObj).forEach(item => {
                let count = item[1].count;
                if (count > 0) {
                    totalChats++;
                    totalCounts = totalCounts + count;
                }
            });
            if (shouldHideNotification() && browserNotify.isPageHidden && totalCounts > 0) {
                updateDisplayName = 'You have ' + totalChats + ' new chat' + (totalChats > 1 ? 's' : '');
                updateMessage = 'Total ' + totalCounts + ' unread message' + (totalCounts > 1 ? 's' : '');
            }
            this.localDb
                .getImageByKey(imageToken, 'profileimages')
                .then(blob => {
                    const createdBlobUrl = window.URL.createObjectURL(blob);
                    let blobUrl = createdBlobUrl;
                    if (shouldHideNotification() && browserNotify.isPageHidden) {
                        blobUrl = '';
                    }
                    sendNotification(updateDisplayName, blobUrl, isRawTag ? message : updateMessage, fromUserId);
                    setTimeout(() => window.URL.revokeObjectURL(createdBlobUrl), 5000);
                })
                .catch(err => {
                    let avatarImage = chatType === 'chat' ? getAvatarImage : groupAvatar;
                    if (shouldHideNotification() && browserNotify.isPageHidden) {
                        avatarImage = '';
                    }
                    sendNotification(updateDisplayName, avatarImage, isRawTag ? message : updateMessage, fromUserId);
                });
        } catch (error) {
        }
    };

    shouldComponentUpdate(nextProps) {
        const {
            unreadCountData: { id, activeUser },
            item: { recent: { msgfrom } = {} },
        } = this.props;
        return !(id && nextProps.unreadCountData.id !== id && msgfrom !== activeUser.msgfrom);
    }

    handleDrop = e => {
        const currentState = this.state.recentDrop;

        // Find the <li> row
        const liEl = e.target.closest('li');
        if (!liEl) {
            this.setState({ recentDrop: !currentState, dropUp: false });
            return;
        }

        const rect = liEl.getBoundingClientRect();
        const spaceBelow = window.innerHeight - rect.bottom;
        const needDropUp = spaceBelow < 200; // tweak 200px based on your dropdown height

        this.setState({
            recentDrop: !currentState,
            dropUp: needDropUp,
        });
    };

    handleDropClose = () => {
        this.setState({
            recentDrop: false,
        });
    };

    handleArchivedChat = async (fromUserId, chatType, archiveStatus) => {
        if (blockOfflineAction()) return;
        this.setState({ recentDrop: false });
        const isArchived = archiveStatus === 0;
        const result = await SDK.updateArchiveChat(formatUserIdToJid(fromUserId, chatType), isArchived);
        if (result?.statusCode === 200) {
            const dispatchData = {
                fromUserId: fromUserId,
                isArchived: isArchived,
            };
            Store.dispatch(updateArchiveStatusRecentChat(dispatchData));
            toast.success(isArchived ? 'Chat archived' : 'Chat unarchived');
        }
    };

    handlePinChat = () => {
        if (blockOfflineAction()) return;
        this.setState(
            prevState => ({
                recentDrop: false,
                pinChat: !prevState.pinChat,
            }),
            () => {
                toast.success(this.state.pinChat === false ? 'Pinned' : 'Unpinned');
            },
        );
    };

    handleRecentChatClick = (e, item) => {
        if (item?.recent?.chatType === 'groupchat') {
            const groupData = this.props.groupsData?.data?.find(ele => ele.groupId === item?.roster?.groupId);
            if (groupData?.isAdminBlocked) {
                this.setState({ showModal: true });
                return;
            }
        }
        this.clickListener(e, item);
    };

    render() {
        const {
            item,
            item: { recent: { fromUserId } = {} } = {},
            searchTerm,
            vCardData,
            messageId,
            callUserJID,
            hidden,
            callStatus,
            enableDropDown = false,
            isAdminBlocked = false,
            callkitData
        } = this.props;

        const {
            callScreenStatus: kitStatus,
            makeCallDetails,
            incomingCallDetails,
            groupId: callGroupId,
            callType: callTypeKit,
            callMode: callModeKit
        } = callkitData || {};

        let kitActiveCallJid = "";
        if (kitStatus && kitStatus !== CALLKIT_CALLSCREENSTATUS.IDLE && kitStatus !== CALLKIT_CALLSCREENSTATUS.ENDED) {
            if (callModeKit === 'ONE-TO-MANY' || callModeKit === 'MEET') {
                kitActiveCallJid = callGroupId;
            } else {
                kitActiveCallJid = (makeCallDetails?.calleeId?.[0]) || (incomingCallDetails?.from) || (incomingCallDetails?.callerId);
            }
        }
        if (kitActiveCallJid && kitActiveCallJid.includes("@")) {
            kitActiveCallJid = kitActiveCallJid.split("@")[0];
        }

        const currentActiveCallJID = kitActiveCallJid || callUserJID;
        const isActiveCall = isMatchingUserId(fromUserId, currentActiveCallJID);
        const currentCallStatus = kitStatus || callStatus;

        const typeOfCall = (callTypeKit || this.props.callType || "").toLowerCase();
        const modeOfCall = (callModeKit || this.props.callMode || "").toLowerCase();

        const ongoingCallDisplayText =
            'Ongoing ' +
            (modeOfCall === 'onetomany' || modeOfCall === 'one-to-many' || modeOfCall === 'one-to-many' ? 'group ' : ' ') +
            typeOfCall +
            ' call…';

        const localUser = (callkitData?.ongoingCallParticipants || []).find(p => isLocalUser(p.userId));
        const kitIsMuted = localUser?.isAudioMuted || false;

        const {
            item: { roster: { image, groupImage, thumbImage } = {} } = {},
            callLogData: { callAudioMute = false } = {},
            pageType = '',
            UnreadUserObjData,
        } = this.props;
        const {
            roster: { groupId, emailId, userId },
            recent: {
                chatType,
                createdAt,
                msgStatus,
                msgType,
                deleteStatus,
                muteStatus,
                archiveStatus,
                seenReceipt,
                reactedUserName,
                emojiId,
            } = {},
        } = item;

        const lastMessage = this.handleMessageType(item);
        const messageDeliveryTime = (createdAt && getConversationHistoryTime(createdAt)) || null;
        const contactName = this.getContactName();
        const iniTail = initialNameHandle(item.roster);
        const hightlightText = contactName ? getHighlightedText(contactName, searchTerm) : fromUserId;
        const token = getFromLocalStorageAndDecrypt('token');
        if (chatType === 'groupchat' && !groupId) return null;

        let selectedRoster = this.props.selectedRoster;
        let selectedJid = '';

        if (selectedRoster?.data?.roster) {
            selectedJid = selectedRoster.data.roster.userId;
            if (selectedJid === undefined) {
                selectedJid = selectedRoster.data.roster.groupId;
            }
        }
        const {
            unreadCountData: { unreadDataObj },
        } = this.props;
        let unreadCount = unreadDataObj[fromUserId]?.count || 0;

        const activeClass = userId || groupId;
        const { recentDrop, pinChat, archiveChat, showModal } = this.state;
        const isPermanentArchvie = getArchiveSetting();
        let imageToken = '';
        if (!isAdminBlocked) {
            imageToken = thumbImage && thumbImage !== '' ? thumbImage : image || groupImage;
        }
        const msgCounts = UnreadUserObjData[fromUserId]?.count;
        if (unreadCount == 0 && msgCounts && msgCounts != 0) {
            unreadCount = msgCounts;
        }

        return (
            <Fragment>
                <li
                    style={{ display: hidden ? 'none' : '' }}
                    className={`chat-list-li ${pageType ? 'recentLiCustom' : ''} ${activeClass === selectedJid ? 'active' : ''} ${recentDrop ? 'set-top' : ''} ${isActiveCall ? 'activeCall' : ''}`}
                    id="chat-list-id"
                    data-name="list"
                    data-chat-id={fromUserId}
                    tabIndex="0"
                    role="button"
                    onClick={e => {
                        if (allowedIds.includes(e.target.id)) return;
                        this.handleRecentChatClick(e, item);
                    }}
                    onKeyDown={e => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            if (allowedIds.includes(e.target.id)) return;
                            this.handleRecentChatClick(e, item);
                        }
                    }}
                >
                    <ProfileImage
                        chatType={chatType}
                        userToken={token}
                        userId={userId || groupId}
                        temporary={false}
                        imageToken={imageToken}
                        emailId={emailId}
                        name={iniTail}
                    />
                    <div className="recentchats">
                        <div className="recent-username-block">
                            <div className="recent-username">
                                <div className="username">
                                    <h3 title={contactName}>
                                        {hightlightText}
                                        {Boolean(isAdminBlocked) && (
                                            <span className="inactive-user-tag">(Inactive User)</span>
                                        )}
                                    </h3>
                                </div>
                            </div>
                            <div className="recent-time-menu">
                            {lastMessage && (
                                <span
                                    className={
                                        unreadCount && parseInt(unreadCount) != 0 ? 'messagetime-plus' : 'messagetime'
                                    }
                                >
                                    {messageDeliveryTime}
                                </span>
                            )}
                            {enableDropDown && fromUserId !== callUserJID && (
                                <div className="recent-menu-container">
                                    {recentDrop && (
                                        <div className="recentDrop">
                                            <OutsideClickHandler onOutsideClick={() => this.handleDropClose()}>
                                                <ul
                                                    className={`menu-dropdown ${this.state.dropUp ? 'drop-up' : 'drop-down'} open`}
                                                >
                                                    <li
                                                        onClick={e => {
                                                            e.stopPropagation();
                                                            this.handleArchivedChat(fromUserId, chatType, archiveStatus);
                                                        }}
                                                        className="menu-dropdown-list-item"
                                                        title={archiveChat ? 'Archived Chat' : 'Unarchived Chat'}
                                                        id="recent-menu-archive"
                                                        tabIndex="0"
                                                        role="button"
                                                        onKeyDown={e => {
                                                            if (e.key === 'Enter' || e.key === ' ') {
                                                                e.stopPropagation();
                                                                this.handleArchivedChat(
                                                                    fromUserId,
                                                                    chatType,
                                                                    archiveStatus,
                                                                );
                                                            }
                                                        }}
                                                    >
                                                        <i className="icon" id="recent-menu-archive-icon">
                                                            {archiveStatus === 0 ? <Archived /> : <IconUnarchive />}
                                                        </i>
                                                        <span className="label" id="recent-menu-archive-text">
                                                            {archiveStatus === 0 ? 'Archive Chat' : 'Unarchive Chat'}
                                                        </span>
                                                    </li>
                                                </ul>
                                            </OutsideClickHandler>
                                        </div>
                                    )}
                                    <span className={`recentMenu ${recentDrop && 'active'}`}>
                                        <div
                                            className="recentMenuOverlay"
                                            id="recent-menu"
                                            onClick={this.handleDrop}
                                        ></div>
                                        <DropdownArrow style={{ fill: `${recentDrop ? 'black' : 'black'}` }} />
                                    </span>
                                </div>
                            )}
                            </div>
                        </div>
                        <div className="recent-message-block">
                            {isActiveCall && (
                                <>
                                    <div
                                        className="iconOnGoingCall"
                                        onClick={this.props.handleShowCallScreen}
                                        tabIndex="0"
                                        role="button"
                                        onKeyDown={e => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                this.props.handleShowCallScreen();
                                            }
                                        }}
                                    >
                                        {typeOfCall === 'audio' ? (
                                            <i className="iconAudioCall">
                                                <RecentAudioCall />
                                            </i>
                                        ) : (
                                            <i className="iconvideoCall">
                                                <RecentVideoCall />
                                            </i>
                                        )}
                                    </div>
                                    <span
                                        className="callDetails"
                                        onClick={this.props.handleShowCallScreen}
                                        onKeyDown={e => e.key === 'Enter' && this.props.handleShowCallScreen}
                                        tabIndex="0"
                                        role="button"
                                    >
                                        {ongoingCallDisplayText}
                                    </span>
                                </>
                            )}
                            <Message
                                msgStatus={msgStatus}
                                lastMessage={lastMessage}
                                messageId={messageId}
                                fromUserId={fromUserId}
                                chatUserType={chatType}
                                msgType={msgType}
                                publisherId={item.recent.publisherId}
                                fromUser={vCardData?.data?.fromUser}
                                deleteStatus={deleteStatus}
                                seenReceipt={seenReceipt}
                                reactedUserName={reactedUserName}
                                emojiId={emojiId}

                            />
                            <div className="recent-message-icon">
                                {((muteStatus === 1 && pageType === 'recent') ||
                                    (muteStatus === 1 && pageType === 'archive' && !isPermanentArchvie)) && (
                                    <i className="MuteChat">
                                        <ChatMute />
                                    </i>
                                )}
                                {pinChat && (
                                    <i className="pinChat">
                                        <IconPinChat style={{ color: '#005386' }} />
                                    </i>
                                )}
                                {parseInt(unreadCount) != 0 && <p className="notifi">{unreadCount}</p>}
                                {archiveStatus === 1 && searchTerm && <span className="recent-badge">Archived</span>}
                            </div>
                        </div>
                    </div>
                    {isActiveCall && (
                        <div className="CallAction">
                            {currentCallStatus && currentCallStatus.toLowerCase() === 'connected' && (
                                <i
                                    onClick={this.handleToggleMute}
                                    title="Mute/Unmute"
                                    className={kitIsMuted ? 'Mute' : ''}
                                    onKeyDown={e => e.key === 'Enter' && this.handleToggleMute}
                                    tabIndex="0"
                                    role="button"
                                >
                                    {kitIsMuted ? <AudioOff /> : <AudioOn />}
                                </i>
                            )}
                            <i
                                title="Hangup"
                                className="Hangup"
                                onClick={this.handleToggleHangUpCall}
                                onKeyDown={e => e.key === 'Enter' && this.handleToggleHangUpCall}
                                tabIndex="0"
                                role="button"
                            >
                                <RecentCallHangup />
                            </i>
                        </div>
                    )}
                </li>
                {showModal && (
                    <Modal containerId="container">
                        <div className="popup-wrapper BlockedPopUp">
                            <div className="popup-container">
                                <div className="popup-container-inner" style={{ maxWidth: '23em' }}>
                                    <div className="popup-label">
                                        <label>{'This group is no longer available'}</label>
                                    </div>
                                    <div className="popup-noteinfo">
                                        <button
                                            onClick={() => this.setState({ showModal: false })}
                                            type="button"
                                            name="btn-action"
                                            className="popup btn-action danger"
                                        >
                                            {'OK'}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal>
                )}
            </Fragment>
        );
    }
}

function MuteChat({ muteStatus, userId }) {
    const dispatch = useDispatch();
    const handleMute = async () => {
        if (blockOfflineAction()) return;

        const isNotMuted = muteStatus !== MUTE_STATUS.MUTED;
        const chatJid = formatUserIdToJid(userId);

        SDK.updateMuteNotification([chatJid], isNotMuted);
        const dispatchData = {
            fromUserId: userId,
            isMuted: isNotMuted,
        };

        updateMuteNotification(dispatchData);
        dispatch(updateMuteStatusRecentChat(dispatchData));
    };
    return (
        <li className="menu-dropdown-list-item" onClick={handleMute}>
            {muteStatus === MUTE_STATUS.NOT_MUTED ? <MuteInfo2 className="icon" /> : <UnMuteInfo2 className="icon" />}
            <div className="label">Mute Chat</div>
        </li>
    );
}

function DeleteChat({ userId, type = CHAT_TYPE_SINGLE }) {
    const featureStateData = useSelector(state => state.featureStateData);
    const [showDelete, setShowDelete] = useState(false);
    const handleDelete = () => {
        if (type === CHAT_TYPE_GROUP) SDK.userDeleteGroup(formatGroupIdToJid(userId));
        else SDK.deleteChat(formatUserIdToJid(userId));
        setShowDelete(false);
    };

    return (
        <>
            {featureStateData.isDeleteChatEnabled && (
                <li
                    className="menu-dropdown-list-item"
                    onClick={() => {
                        setShowDelete(true);
                    }}
                >
                    <Delete className="icon" />
                    <div className="destructive label">Delete Chat</div>
                    {showDelete && (
                        <Dialog open={showDelete} onOpenChange={setShowDelete}>
                            <DialogContent>
                                <DialogHeader>
                                    <DialogTitle>Delete Chat</DialogTitle>
                                    <DialogDescription>
                                        All messages in this chat will be deleted from all your devices.
                                    </DialogDescription>
                                </DialogHeader>

                                <DialogFooter>
                                    <DialogClose>Cancel</DialogClose>
                                    <DialogAction onClick={handleDelete} variant="destructive">
                                        Delete
                                    </DialogAction>
                                </DialogFooter>
                            </DialogContent>
                        </Dialog>
                    )}
                </li>
            )}
        </>
    );
}

function LeaveChat({ groupId }) {
    const groupsMemberParticipantsListData = useSelector(state => state.groupsMemberParticipantsListData);
    const groupJid = formatGroupIdToJid(groupId);
    const participants = groupsMemberParticipantsListData.groupParticipants?.[groupJid];
    const userDataInGroup = participants?.find(users => isLocalUser(users.userId));

    const [showLeave, setShowLeave] = useState(false);

    const handleLeave = async (deleteChat = false) => {
        if (!isAppOnline()) {
            blockOfflineAction();
            return;
        }
        if (!userDataInGroup) {
            console.warn('User not found in group participants');
            return;
        }
        const userJid = userDataInGroup.userJid;

        try {
            const exitResponse = await SDK.userExitGroup(groupJid, userJid);

            if (exitResponse?.statusCode !== 200) {
                toast.error(exitResponse?.message || 'Failed to exit the group.');
                return;
            }

            toast.info('You left the group.');

            if (deleteChat) {
                const deleteResponse = await SDK.userDeleteGroup(groupJid);

                if (deleteResponse?.statusCode !== 200) {
                    toast.error(deleteResponse?.message || 'Exited group, but failed to delete the chat.');
                    return;
                }

                toast.info('Group chat deleted successfully.');
            }
        } catch (error) {
            console.error('Group operation error:', error);
            toast.error(error?.message || 'Something went wrong while processing the group action.');
        }
    };

    return userDataInGroup ? (
        <>
            <li
                className="menu-dropdown-list-item"
                onClick={() => {
                    setShowLeave(true);
                }}
            >
                <LeaveIcon className="icon" />
                <div className="destructive label">Leave Group</div>
                {showLeave && (
                    <Dialog open={showLeave} onOpenChange={setShowLeave}>
                        <DialogContent>
                            <DialogHeader>
                                <DialogTitle>Leave Group</DialogTitle>
                                <DialogDescription>Are you sure you want to leave this group?</DialogDescription>
                            </DialogHeader>

                            <DialogFooter>
                                <DialogClose>Cancel</DialogClose>
                                <DialogAction onClick={() => handleLeave(false)} variant="secondary">
                                    Leave Group
                                </DialogAction>
                                <DialogAction onClick={() => handleLeave(true)} variant="destructive">
                                    Leave and Delete Chat
                                </DialogAction>
                            </DialogFooter>
                        </DialogContent>
                    </Dialog>
                )}
            </li>
        </>
    ) : (
        <DeleteChat userId={groupId} type={CHAT_TYPE_GROUP} />
    );
}

const mapStateToProps = (state, props) => {
    return {
        vCardData: state.vCardData,
        rosterData: state.rosterData,
        blockedContact: state.blockedContact,
        unreadCountData: state.unreadCountData,
        selectedRoster: state.activeChatData,
        contactsWhoBlockedMe: state.contactsWhoBlockedMe,
        groupsData: state.groupsData,
        callLogData: state.callLogData,
        UnreadUserObjData: state.UnreadUserObjData,
        callkitData: state.callkitData,
    };
};
export default connect(mapStateToProps, null)(RecentChatItem);

RecentChatItem.propTypes = {
    messageId: PropTypes.string,
    callUserJID: PropTypes.string,
    callStatus: PropTypes.string,
    callType: PropTypes.string,
    callMode: PropTypes.string,
    handleOnclick: PropTypes.func,
    handleShowCallScreen: PropTypes.func,
    messageData: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    searchTerm: PropTypes.string,
    pageType: PropTypes.string,
    refreshUnreadCount: PropTypes.bool,
    handlePopupState: PropTypes.func,
    selectedRoster: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    callLogData: PropTypes.object,
    vCardData: PropTypes.object,
    item: PropTypes.object,
    unreadCountData: PropTypes.object,
    groupsData: PropTypes.object,
    hidden: PropTypes.bool,
    enableDropDown: PropTypes.bool,
    isAdminBlocked: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    UnreadUserObjData: PropTypes.object,
    rosterData: PropTypes.object,
};
